import { assoc } from 'ramda'
import axiosClient from 'axios'
import store from '@/store'
import router from '@/router'

const axios = axiosClient.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'content-type': 'application/x-www-form-urlencoded',
    },
})

axios.interceptors.request.use((config) => {
    const headers = config?.headers || {}
    headers['Authorization'] = `Bearer ${store.state.accessToken}`

    return assoc('headers', headers, config)
})

axios.interceptors.response.use(response => {
    return response
}, error => {
    if (error.response?.status === 401) {
        store.dispatch('logout')
        router.replace({ name: 'Login' })
        return
    }

    throw error
})

export default axios
